export const gridRows = 16;
export const gridCols = 100;

// Cursor helped a ton!

// Top chart anchor values
const topChartColStart = 1;
const topChartColEnd = 81;
const topChartRowStart = 1;
const topChartRowEnd = 7;

const numberOfFactboxes = 4;

// Fixed configs for each group
type FixedGridConfig = {
  baseCol: number;
  baseRow: number;
  colSpan: number;
  rowSpan: number;
  direction?: 'row' | 'col';
};

const topChartConfig: FixedGridConfig = {
  baseCol: topChartColStart,
  baseRow: topChartRowStart,
  colSpan: topChartColEnd - topChartColStart,
  rowSpan: topChartRowEnd - topChartRowStart,
};

const factboxConfig: FixedGridConfig = {
  baseCol: topChartColEnd,
  baseRow: topChartRowStart,
  colSpan: gridCols - topChartColEnd + 1,
  rowSpan: Math.floor((gridRows - topChartRowStart + 1) / numberOfFactboxes),
  direction: 'col',
};

// Middle charts (2 charts, each 5 columns wide, rows 7-11)
const middleChartConfig: FixedGridConfig = {
  baseCol: 1,
  baseRow: 7,
  colSpan: 39,
  rowSpan: 5,
  direction: 'row',
};

// Bottom charts (5 charts, each 2 columns wide, rows 12-16)
const getBottomChartConfig = (numCharts: number): FixedGridConfig => {
  const colSpan = Math.floor((topChartColEnd - 1) / numCharts);
  return {
    baseCol: 1,
    baseRow: 12,
    colSpan,
    rowSpan: 5,
    direction: 'row',
  };
};

// Helper function for grid config
type GridConfigParams = FixedGridConfig & { position: number };

function makeGridConfig({
  baseCol,
  baseRow,
  colSpan,
  rowSpan,
  position,
  direction = 'row',
}: GridConfigParams) {
  if (direction === 'row') {
    return {
      gridColStart: baseCol + (position - 1) * colSpan,
      gridColEnd: baseCol + position * colSpan,
      gridRowStart: baseRow,
      gridRowEnd: baseRow + rowSpan,
    };
  } else {
    // direction === 'col', items placed vertically
    return {
      gridColStart: baseCol,
      gridColEnd: baseCol + colSpan,
      gridRowStart: baseRow + (position - 1) * rowSpan,
      gridRowEnd: baseRow + position * rowSpan,
    };
  }
}

// Top chart config
export const topLineChartGridConfig = {
  gridColStart: topChartConfig.baseCol,
  gridColEnd: topChartConfig.baseCol + topChartConfig.colSpan,
  gridRowStart: topChartConfig.baseRow,
  gridRowEnd: topChartConfig.baseRow + topChartConfig.rowSpan,
};

export const getFactboxGridConfig = (position: number) =>
  makeGridConfig({ ...factboxConfig, position });
export const getMiddleChartGridConfig = (position: number) =>
  makeGridConfig({ ...middleChartConfig, position });
